// extracted by mini-css-extract-plugin
module.exports = {"comp":"NavPage_comp__J3SuD"};